import Vue from 'vue'
import { AclCreate, AclInstaller, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'all'
if (localStorage.getItem('userRole')) initialRole = localStorage.getItem('userRole')

export default new AclCreate({
    initial: initialRole,
    notfound: '/pages/not-authorized',
    router,
    acceptLocalRules: true,
    globalRules: {
        root: new AclRule('root').generate(),
        administrator: new AclRule('administrator').generate(),
        root_admin: new AclRule('root').or('administrator').generate(),
        unverified_merchant: new AclRule('unverified_merchant').generate(),
        merchant_child: new AclRule('merchant_child').generate(),
        merchant_admin: new AclRule('merchant_admin').or('merchant_child').generate(),
        merchant_ops: new AclRule('merchant_ops').generate(),
        merchant_finance: new AclRule('merchant_finance').generate(),
        issuer_user: new AclRule('issuer_user').generate(),
        aino_pios: new AclRule('aino_pios').generate(),
        aino_finance: new AclRule('aino_finance').generate(),
        aino_cc: new AclRule('aino_cc').generate(),
        aino_recon: new AclRule('aino_recon').generate(),
        aino_recon_child: new AclRule('aino_recon_child').generate(),
        customer_service: new AclRule('customer_service').generate(),
        all_merchant: new AclRule('all_merchant').or('merchant_admin').or('merchant_ops').or('merchant_finance').generate(),
        all_admin_aino: new AclRule('all_admin_aino').or('root').or('administrator').or('aino_itops').generate(),
        all_aino: new AclRule('all_aino').or('root').or('administrator').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_finance').or('aino_cc').generate(),
        all_internal_aino: new AclRule('all_internal_aino').or('root').or('administrator').or('aino_itops').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_finance').or('aino_cc').generate(),
        all_verified: new AclRule('all_verified').or('root').or('administrator').or('merchant_admin').or('merchant_ops').or('merchant_finance').or('issuer_user').or('aino_pios').or('aino_finance').or('aino_cc').or('aino_recon').or('aino_recon_child').generate(),
        all: new AclRule('all').or('root').or('administrator').or('merchant_admin').or('merchant_ops').or('merchant_finance').or('issuer_user').or('aino_pios').or('aino_finance').or('aino_cc').or('aino_recon').or('aino_recon_child').or('unverified_merchant').or('customer_service').generate(),

        services: new AclRule('services').or('root').or('administrator').or('merchant_admin').or('merchant_ops').or('merchant_finance').or('issuer_user').or('aino_pios').or('aino_finance').or('aino_cc').or('aino_recon').or('aino_recon_child').or('customer_service').generate(),
        account_information: new AclRule('account_information').or('merchant_admin').or('merchant_ops').or('merchant_finance').or('unverified_merchant').generate(),
        merchant_verification: new AclRule('merchant_verification').or('root').or('administrator').or('aino_cc').generate(),
        merchant_management: new AclRule('merchant_management').or('root').or('administrator').or('aino_recon').or('aino_recon_child').or('aino_finance').or('aino_cc').generate(),
        merchant_verification_account: new AclRule('merchant_verification_account').or('root').or('administrator').or('aino_cc').or('merchant_admin').or('unverified_merchant').generate(),
        merchant_configuration: new AclRule('merchant_configuration').or('root').or('administrator').or('aino_finance').or('aino_cc').or('merchant_admin').or('merchant_ops').generate(),
        request_device: new AclRule('request_device').or('root').or('administrator').or('merchant_admin').or('merchant_ops').generate(),

        device_assignment: new AclRule('device_assignment').or('root').or('administrator').or('aino_cc').generate(),
        device_type: new AclRule('device_type').or('root').or('administrator').or('aino_cc').generate(),
        device_registration: new AclRule('device_registration').or('root').or('administrator').or('aino_cc').generate(),
        device_report: new AclRule('device_report').or('root').or('administrator').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_finance').or('aino_cc').or('customer_service').generate(),
        device_monitoring: new AclRule('device_monitoring').or('root').or('administrator').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_cc').or('merchant_admin').or('merchant_ops').or('customer_service').generate(),
        device_trans_summary: new AclRule('device_trans_summary').or('root').or('administrator').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_finance').or('aino_cc').or('merchant_admin').or('merchant_ops').or('merchant_finance').or('customer_service').generate(),

        user_management: new AclRule('user_management').or('root').or('administrator').or('aino_cc').generate(),
        shiftdate_mapping: new AclRule('shiftdate_mapping').or('root').or('administrator').or('aino_pios').generate(),

        device_and_location_mapping: new AclRule('device_and_location_mapping').or('root').or('administrator').or('aino_itops').or('aino_recon').or('aino_recon_child').or('aino_pios').or('aino_finance').or('aino_cc').or('customer_service').generate(),
    }
})
// Services --
// manage payment
// dashboard
// merchant configuration
// summary settlement
// merchant management
// device report
// merchant verification
// device type
// device registration
// device assignment
// device monitoring
// user management
// transaction
// transaction tracking
// issuer settlement
// merchant settlement
// account statement
// settle by id
// reconciliation report
// consolidation report
// issuer configuration
// payment method configuration
// payment channel configuration
// request for device
//     account information

// admin: new AclRule('administrator').or('root').generate(),
//     unverified_merchant: new AclRule('unverified_merchant').generate(),
//     merchant_admin: new AclRule('merchant_admin').generate(),
//     merchant_child: new AclRule('merchant_child').generate(),
//     merchant: new AclRule('merchant').or('merchant_admin').generate(),
//     merchant_all: new AclRule('merchant_all').or('merchant_admin').or('unverified_merchant').or('merchant_child').generate(),
//     all_admin: new AclRule('all_admin').or('administrator').or('merchant_admin').or('root').generate(),
//     all_admin_and_issuer: new AclRule('all_admin')
//     .or('administrator')
//     .or('merchant_admin')
//     .or('root')
//     .or('issuer_user')
//     .generate(),
//     all: new AclRule('all')
//     .or('administrator')
//     .or('root')
//     .or('merchant_all')
//     .or('merchant_admin')
//     .or('unverified_merchant')
//     .or('merchant_child')
//     .or('issuer_user')
//     .generate(),
//     editor: new AclRule('editor').or('all').or('administrator').or('root').generate(),
//     issuer: new AclRule('issuer_user')